import { EditorContextService } from '@magnolia/frontend-helpers-base';
import { defineElement, TemplateElement } from '@webtides/element-js';

class MgnlEditableCommment extends TemplateElement {
    properties() {
        return {
            annotation: null,
            shouldRefresh: false,
            shouldRunOnFrameReady: false,
            alwaysRender: false,
        };
    }
    injectProperties() {
        return { mgnlContext: null };
    }

    async connected() {
        if (this.shouldRefresh) {
            EditorContextService.refresh(10);
        }
    }

    template() {
        return `<!--${this.annotation}-->`;
    }
}

defineElement('mgnl-editable-comment', MgnlEditableCommment);
